import React from "react";
import { Link } from "react-router-dom";
import useReveal from "../../hooks/useReveal";
import { BDK, waUrl } from "../../config/bdk";
import PortfolioCard from "./PortfolioCard";

const PORTFOLIO_PREVIEW_LIMIT = 6;

const Portfolio = () => {
  useReveal();
  return (
    <section
      id="portfolio"
      data-testid="section-portfolio"
      className="bdk-section"
      style={{ background: "var(--paper)" }}
    >
      <div className="container-bdk">
        <div className="max-w-[760px] mx-auto text-center mb-14 bdk-reveal bdk-reveal--up">
          <p className="kicker">Ejemplos reales</p>
          <h2 className="font-display text-[38px] sm:text-[48px] md:text-[56px] lg:text-[64px]">
            Así podría verse la página
            <br />
            de tu negocio.
          </h2>
          <p className="mt-5 text-[#666873] text-[15px] md:text-[16px]">
            Estos son sitios reales diseñados por BDKSISTEMAS. Tu página se
            adapta al giro, colores y estilo de tu negocio.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {BDK.portfolio.slice(0, PORTFOLIO_PREVIEW_LIMIT).map((p, i) => (
            <PortfolioCard key={p.name} p={p} i={i} />
          ))}
        </div>

        {BDK.portfolio.length > PORTFOLIO_PREVIEW_LIMIT && (
          <div className="mt-8 text-center bdk-reveal bdk-reveal--up">
            <Link
              to="/portafolio-paginas"
              data-testid="portfolio-ver-completo"
              className="bdk-btn bdk-btn--outline"
            >
              Ver portafolio completo
            </Link>
          </div>
        )}

        <div
          className="mt-12 rounded-[14px] bg-white p-7 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-5 bdk-reveal bdk-reveal--up"
          style={{ border: "1px solid var(--line)" }}
        >
          <div>
            <h3 className="font-display text-[26px] md:text-[28px] uppercase leading-none">
              ¿Quieres una página así para tu negocio?
            </h3>
            <p className="text-[#666873] text-[13px] mt-2">
              La personalizamos con tu logo, colores, promociones y estilo.
            </p>
          </div>
          <a
            href={waUrl(
              "Hola, vi los ejemplos de BDKSISTEMAS y quiero información para una página como esas para mi negocio."
            )}
            target="_blank"
            rel="noreferrer"
            data-testid="portfolio-inline-cta"
            onClick={() => window.fbq?.("trackCustom", "ClickPortafolio")}
            className="bdk-btn bdk-btn--primary flex-shrink-0"
          >
            Quiero una página así
          </a>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
